<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="18.778" height="18.826" viewBox="0 0 18.778 18.826">
		<path
			id="Path_19978"
			data-name="Path 19978"
			d="M1179.568,485.233l-1.964-6.742a7.085,7.085,0,0,0-8.66-4.674,6.856,6.856,0,0,0-4.993,5.013l-1.518,6.511a2.159,2.159,0,0,0,1.727,2.575,2.384,2.384,0,0,0,.487.051h2.728a3.779,3.779,0,0,0,4.452,2.807,3.688,3.688,0,0,0,2.945-2.807h2.619a2.213,2.213,0,0,0,2.267-2.159,2.053,2.053,0,0,0-.081-.572Zm-12.2,2.734h7.4"
			transform="translate(-1161.632 -472.786)"
			fill="none"
			stroke="#727994"
			stroke-miterlimit="10"
			stroke-width="1.5"
		/>
	</svg>
</template>

<script>
export default {
	name: 'AlertsSVG',
};
</script>
